module.exports = __webpack_public_path__ + "static/offerTop-6b58d76d4641ed57d962015dd6e065f3.png";